<app-header></app-header>
<div class="flex">
    <div class="sidebarContainer" [class.hide]="toggle">
        <app-sidebar></app-sidebar>
    </div>
    <div class="mainContainer" [class.maximum]="toggle"  [class.minimum]="!toggle">
      <router-outlet></router-outlet>
      <!-- <app-main></app-main> -->
    </div>
</div>